import React from 'react'

import { spinner } from './Spinner.css'

export type SpinnerProps = {
  width: number
  height: number
}

export const Spinner: React.FC<SpinnerProps> = ({ width, height }) => {
  return (
    <div
      className={spinner}
      style={{
        width: width + 'px',
        height: height + 'px',
        backgroundColor: 'transparent',
      }}
    />
  )
}
